<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="1000px"
    :title="title"
    :before-close="() => $refs.editForm.cancel()"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    :modal="false"
    v-el-dialog-drag
  >
    <EditForm
      ref="editForm"
      @reload="$emit('reload')"
      @close="close"
      :orderBatchCode="orderBatchCode"
      :orderCode="orderCode"
      :optType="optType"
      :orderType="orderType"
      :custCode="custCode"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.editForm.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        type="primary"
        size="small"
        v-if="optType !== 'detail'"
        @click="$refs.editForm.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditForm from './index.vue'
export default {
  components: { EditForm },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    orderBatchCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    optType: { type: String, default: '' },
    orderType: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
